import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('vidyacards_user')); } catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('vidyacards_token');
    if (token) {
      authAPI.getMe()
        .then(res => setUser(res.data.user))
        .catch(() => { localStorage.removeItem('vidyacards_token'); setUser(null); })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  // ── Email + password login (unchanged) ──────────────────────────────────
  const login = useCallback(async (email, password) => {
    const res = await authAPI.login({ email, password });
    localStorage.setItem('vidyacards_token', res.data.token);
    localStorage.setItem('vidyacards_user', JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data;
  }, []);

  // ── Called after OTP verification (register OR phone login) ────────────
  // Pass the token + user object returned from verify-otp / verify-phone-otp
  const loginWithData = useCallback((token, userData) => {
    localStorage.setItem('vidyacards_token', token);
    localStorage.setItem('vidyacards_user', JSON.stringify(userData));
    setUser(userData);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('vidyacards_token');
    localStorage.removeItem('vidyacards_user');
    setUser(null);
  }, []);

  const updateUser = useCallback((updated) => {
    setUser(updated);
    localStorage.setItem('vidyacards_user', JSON.stringify(updated));
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, login, loginWithData, logout, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);